import React, { Component } from "react";

import "./style.scss";

import StepOne from "./step_1.js";
import StepTwo from "./step_2.js";
import StepThree from "./step_3.js";

export default class SignUp extends Component {
  constructor(props) {
    super(props);
    let abossPackage = undefined;
    let pricing = undefined;
    let step = 1;

    if (window.location.hash.includes("agency")) {
      step = 2;
      abossPackage = "agency";
    }
    if (window.location.hash.includes("agency-small")) {
      step = 3;
      pricing = 1572;
      abossPackage = "agency";
    }
    if (window.location.hash.includes("agency-medium")) {
      step = 3;
      pricing = 3456;
      abossPackage = "agency";
    }
    if (window.location.hash.includes("agency-large")) {
      step = 3;
      pricing = 6264;
      abossPackage = "agency";
    }
    if (window.location.hash.includes("artist")) {
      step = 2;
      abossPackage = "artist";
    }
    if (window.location.hash.includes("artist-year")) {
      step = 3;
      pricing = 528;
      abossPackage = "artist";
    }
    if (window.location.hash.includes("artist-month")) {
      step = 3;
      pricing = 49;
      abossPackage = "artist";
    }

    this.state = {
      abossPackage: abossPackage,
      pricing: pricing,
      step: step
    };
  }

  selectPackage = e => {
    this.setState({
      abossPackage: e,
      step: 2
    });
  };

  selectArtistPricing = e => {
    this.setState({
      pricing: e,
      step: 3
    });
  };

  render() {
    if (this.state.step === 1) {
      return <StepOne selectPackage={this.selectPackage} />;
    } else if (this.state.step === 2) {
      return (
        <StepTwo
          selectArtistPricing={this.selectArtistPricing}
          {...this.state}
        />
      );
    } else if (this.state.step === 3) {
      return <StepThree {...this.state} />;
    } else {
      return <div></div>;
    }
  }
}



// WEBPACK FOOTER //
// src/views/sign-up/index.js